module.exports = __webpack_public_path__ + "static/img/geometry2.f659c4d5.jpg";